import { defineComponent as _defineComponent } from 'vue'
import { computedWithControl, watchDebounced } from '@vueuse/core';
import { ref, computed, getCurrentInstance, watch } from 'vue'
import { VDataTable } from "vuetify/lib/components/VDataTable";
import { filterColumn } from "@/utils/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTable',
  props: ["headers", "items"],
  setup(__props) {

const props = __props;



// const start = ref(0)
// const itemsPerPage = 40
// const end = ref( itemsPerPage )

// const display = computed(() => props.items.slice(start.value, end.value))

const refs = getCurrentInstance()?.proxy.$refs
const slots = { ...getCurrentInstance()?.proxy.$scopedSlots, ...getCurrentInstance()?.proxy.$scopedSlots }

const inlineFilters = ref({});

const _items = computed<any[]>(() => props.items);
const _headers = computed<any[]>(() =>
  props.headers.map((h) => ({ dataType: "text", ...h }))
);

const dataTypes = computed(() =>
  _headers.value.reduce((t, h) => {
    t[h.key] = h.dataType || "text";
    return t;
  }, {})
);

function getProp(obj: Object, key: string) {
  key = key.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  key = key.replace(/^\./, '');           // strip a leading dot
  var a = key.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

const filteredItems = computedWithControl(
  () => { },
  () => {
    return _items.value.filter((imp) =>
      Object.entries(inlineFilters.value).every(([key, val]) => {
        return filterColumn(getProp(imp, key), val, dataTypes.value[key]);
      })
    );
  }
);

watchDebounced([inlineFilters, _items], filteredItems.trigger, {
  deep: true,
  debounce: 200,
  immediate: true,
});


function scrollToRow(index) {
  const table = refs.dataTable.$el.querySelector("table");
  const row = table.rows[index];
  if (row) {
    row.scrollIntoView(true);
  }
}

// function loadMore(entries, observer, isIntersecting) {
//   if (isIntersecting) {
//     const indexesLeft = props.items.length - end.value;
//     if (indexesLeft < itemsPerPage) {
//       // start.value = end.value + indexesLeft - itemsPerPage;
//       end.value = props.items.length;
//     } else {
//       // start.value += itemsPerPage;
//       end.value += itemsPerPage;
//     }
//     // scrollToRow( 23 );
//   }
// }

// function loadLess(entries, observer, isIntersecting) {
//   if (isIntersecting) {
//     if (start.value < itemsPerPage) {
//       start.value = 0;
//       end.value = itemsPerPage;
//     } else {
//       // start.value -= itemsPerPage;
//       end.value -= itemsPerPage;
//     }
//     // scrollToRow( 5 );
//   }
// }


return { __sfc: true,props, refs, slots, inlineFilters, _items, _headers, dataTypes, getProp, filteredItems, scrollToRow, VDataTable }
}

})